import '../types'
import { hasWebview2 } from './xbox/hasWebView2'

export const isXbox = () => {
  return hasWebview2()
}
